import { render, staticRenderFns } from "./update-code.vue?vue&type=template&id=ad8a265e&"
import script from "./update-code.vue?vue&type=script&lang=js&"
export * from "./update-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports